import { createFileRoute } from "@tanstack/react-router";
import { PlaneIcon } from "lucide-react";
import { LeaveManagement } from "@/components/dashboard/leave/leave-management";
import { leaveOverviewQuery, warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/leave")({
  // A head start on the default view; the page renders its own skeleton.
  loader: ({ context }) => {
    warm(context.queryClient.ensureQueryData(leaveOverviewQuery));
  },
  component: LeavePage,
});

function LeavePage() {
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl space-y-6">
        <div className="space-y-1">
          <p className="flex items-center gap-1.5 font-medium text-[10px] text-muted-foreground uppercase tracking-[0.25em]">
            <PlaneIcon className="size-3.5" />
            Leave
          </p>
          <h1 className="font-bold text-2xl tracking-tight">Leave management</h1>
          <p className="text-muted-foreground text-sm">
            Track who's off, approve time off, and manage your team's leave balances.
          </p>
        </div>

        <LeaveManagement />
      </div>
    </main>
  );
}
